import axios from "axios";
import StoreModule from "../core/StoreModule";
import { config } from "@/config";
import { resourceUrl } from "@/utils/stringUtils";
import { WizardInstanceState } from "./state";
import { RESOURCE_PATH, WizardInstanceGetResponse } from "./types";
import { $application } from "../application/store";
import { $wizardMask } from "../wizard_mask/store";
import { axiosExceptionToHttpError } from "@/utils/errorHandling";
import { HttpError } from "../core/HttpError";
import { $appearance } from "../appearance/store";

class WizardInstanceStore extends StoreModule<WizardInstanceState> {
  protected state: WizardInstanceState = {
    wizardInstance: null,
  };

  get wizardInstance() {
    return this.state.wizardInstance;
  }

  set wizardInstance(val: WizardInstanceState["wizardInstance"]) {
    this.setState({ wizardInstance: val });
  }

  /**
   * Returns the wizard instance with given ID.
   *
   * @param id
   */
  async fetch(
    id: string
  ): Promise<[WizardInstanceState["wizardInstance"] | null, HttpError | null]> {
    try {
      const resp = await axios.get<WizardInstanceGetResponse>(
        resourceUrl(config.api.BASE_URL, RESOURCE_PATH, id)
      );
      $application.application = resp.data.application;
      $wizardMask.wizardMask = resp.data.wizardMask;
      this.wizardInstance = {
        id: resp.data.id,
        config: resp.data.config,
        state: resp.data.state,
        origins: resp.data.origins,
        createdAt: resp.data.createdAt,
      };
      if (resp.data.config.layout?.flow == "single-use") {
        $appearance.hideInsertDetails = true;
        $appearance.hideLayoutToolbar = true;
      }
      return [this.wizardInstance, null];
    } catch (err: any) {
      console.log(err);
      if (err.name && err.name == "AxiosError") {
        return [null, axiosExceptionToHttpError(err)];
      }
      return [null, new HttpError(err.message, 500, err.stack)];
    }
  }
}

export const $wizardInstace = StoreModule.singleton(WizardInstanceStore);
